<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showOffboard"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="
            change-height
            fixed
            center-h-v
            bg-white
            rounded-md
            shadow-2xl
            sm:w-3/5
            w-full
          "
        >
          <!-- top bar -->
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Offboard Employee</p>
            <img
              class="
                h-6
                object-contain
                cursor-pointer
                hover:shadow-lg
                bg-primary
                rounded-md
              "
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="grid grid-cols-3 divide-x-1.5 mb-10">
            <div class="h-full w-full col-span-1">
              <div class="p-7">
                <img
                  class="h-20 w-20 rounded-full mx-auto mb-5"
                  src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
                />
                <p class="font-medium text-xl">John Doe</p>
                <p>Sales Manager</p>
                <div class="font-bold flex-col my-3 flex gap-2">
                  <p>
                    <span>&#9993; </span>
                    <a href="mailto:johh@gmail.com">johh@gmail.com</a>
                  </p>
                  <p>
                    <span>&#9742; </span>
                    <a href="tel:0700333333">0700333333</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="h-full w-full col-span-2">
              <div>
                <div class="flex justify-evenly border-b-1.5">
                  <div
                    @click="changeTab(tab)"
                    class="
                      w-full
                      text-center
                      p-3
                      cursor-pointer
                      hover:bg-primary hover:text-white
                    "
                    v-for="(tab, index) in offerTabs"
                    :key="index"
                    :class="selectedTab == tab ? 'bg-primary text-white' : ''"
                  >
                    {{ tab }}
                  </div>
                </div>
                <offboarding-details
                  v-if="selectedTab == 'Job Information'"
                  :key="jiKey"
                ></offboarding-details>
                <offboarding-checklist
                  v-if="selectedTab == 'Checklist'"
                  :key="clKey"
                ></offboarding-checklist>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import OffboardingDetails from './offboardTabs/offboardingDetails.vue';
import OffboardingChecklist from './offboardTabs/offboardingChecklist.vue';
export default {
  name: "OffBoard",
  props: ["showOffboard"],
  components: { OffboardingDetails, OffboardingChecklist },
  data() {
    return {
      selectedTab: "Offboarding Details",
      showMoveToOffer: false,
      offerTabs: ["Offboarding Details", "Checklist"],
      odKey: 0,
      clKey: 1,
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },
    changeTab(tab) {
      this.selectedTab = tab;
      switch (tab) {
        case "Offboarding Details":
          this.odKey++;
          break;
        case "Checklist":
          this.clKey++;
          break;

        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.change-height {
  transition: height 0.15s ease-out;
}
</style>